module.exports = __webpack_public_path__ + "static/media/594.55da0dce.webp";